import { config } from '#app/config'
import type { LatLngTuple } from 'leaflet'

// Add some margin to maxBounds to prevent bouncing when displaying a map overlapping the antimeridian
const antimeridianMargin = 50

const { tileUrl, attribution, accessToken } = config.mapTiles

export default {
  // Init once Leaflet was fetched
  init () {
    // Using @ts-ignore instead of @ts-expect-error as an error is produced in some environment (tsc) and not others (IDE)
    // @ts-ignore L is both a type namespace and a global value
    L.Icon.Default.imagePath = '/public/images/map'
  },
  mapOptions: {
    // This parameter seems to be ignored when passed with the general settings,
    // thus the need to pass it at map initialization
    worldCopyJump: true,
    // As worldCopyJump=true, maxBounds is mostly useful to keep latitudes between -90 and 90
    maxBounds: [
      [ -90, -180 - antimeridianMargin ] as LatLngTuple,
      [ 90, 180 + antimeridianMargin ] as LatLngTuple,
    ],
  },
  tileUrl,
  tileLayerOptions: {
    attribution,
    minZoom: 2,
    maxZoom: 18,
    accessToken,
    // Increase the font size, see https://gis.stackexchange.com/a/346383
    tileSize: 512,
    zoomOffset: -1,
  },
  defaultZoom: 13,
}
